import axios from 'axios'
import { getCookieValue } from '../common-services'
import { BASE_URL } from './../../config'

export const getSearchTableData = async (session, searchBy , searchValue) => {
    const schoolCode = getCookieValue('schoolCode')
    const loginId = getCookieValue('loginId')
    try {
      return await axios.get(
        `${BASE_URL}/api-controller/student/getStudentData.php?schoolCode=${schoolCode}&loginId=${loginId}&searchAdmissions=${searchBy}&class=${searchValue}&session=${session}`
      )
    } catch (err) {
      console.error('Error while getting  search data', err.message)
    }
}

export const getStudents = async (classes , section , session) => {
    const schoolCode = getCookieValue('schoolCode')
    const loginId = getCookieValue('loginId')
    try {
      return await axios.get(
        `${BASE_URL}/api-controller/getCommonData.php?schoolCode=${schoolCode}&loginId=${loginId}&getStudentsByClassSectionSession=1&classId=${classes}&classSecId=${section}&session=${session}`
      )
    } catch (err) {
      console.error('Error while getting  students data', err.message)
    }
}

export const getdocumentType = async() => {
    const schoolCode = getCookieValue('schoolCode')
    const loginId = getCookieValue('loginId')
    try {
      return await axios.get(
        `${BASE_URL}/api-controller/getCommonData.php?schoolCode=${schoolCode}&loginId=${loginId}&getDocTypes=1`
      )
    } catch (err) {
      console.error('Error while getting  documents type', err.message)
    }
}

export const updatedocument = async(formdata) => {
    try {
      return await axios.post(
        `${BASE_URL}/api-controller/student/getStudentData.php?`,formdata
      )
    } catch (err) {
      console.error('Error while getting  documents type', err.message)
    }
}

export const getUploadedDocuments = async(student) => {
    const schoolCode = getCookieValue('schoolCode')
    const loginId = getCookieValue('loginId')
    try {
      return await axios.get(
        `${BASE_URL}/api-controller/student/getStudentData.php?schoolCode=${schoolCode}&loginId=${loginId}&getAllDocuments=1&studentId=${student}`
      )
    } catch (err) {
      console.error('Error while getting  documents type', err.message)
    }
}

export const deleteDocument = async(docId) => {
    const schoolCode = getCookieValue('schoolCode')
    const loginId = getCookieValue('loginId')
    try {
      return await axios.get(
        `${BASE_URL}/api-controller/student/getStudentData.php?schoolCode=${schoolCode}&loginId=${loginId}&deleteAdmissionDocument=1&documentId=${docId}`
      )
    } catch (err) {
      console.error('Error while getting delete documents', err.message)
    }
}

export const getBulkImageTableData = async(classes , section , session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/getCommonData.php?schoolCode=${schoolCode}&loginId=${loginId}&getStudentsByClassSectionSession=1&classId=${classes}&classSecId=${section}&session=${session}`
    )
  } catch (err) {
    console.error('Error while getting delete documents', err.message)
  }
}

export const updateImages = async(formdata) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  formdata.append('schoolCode', schoolCode)
  formdata.append('loginId', loginId)
  try {
    return await axios.post(
      `${BASE_URL}/api-controller/student/getStudentData.php?`,formdata
    )
  } catch (err) {
    console.error('Error while sending  images', err.message)
  }
}

export const importFile = async(formdata) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  formdata.append('schoolCode', schoolCode)
  formdata.append('loginId', loginId)
  try {
    return await axios.post(
      `${BASE_URL}/api-controller/student/getStudentData.php?`,formdata
    )
  } catch (err) {
    console.error('Error while import file', err.message)
  }
}

export const getMotherTongue = async() => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/GetMotherTongue.php?GetMotherTongue=GetMotherTongue&schoolCode=${schoolCode}&loginId=${loginId}`
    )
  } catch (err) {
    console.error('Error while getting mother tongue table', err.message)
  }
}

export const saveMotherTongue = async(formdata) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  formdata.append('schoolCode', schoolCode)
  formdata.append('loginId', loginId)
  try {
    return await axios.post(
      `${BASE_URL}/AddMotherTongue1.php?`,formdata
    )
  } catch (err) {
    console.error('Error while adding mother tongue', err.message)
  }
}

export const updateMotherTongue = async(formdata) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  formdata.append('schoolCode', schoolCode)
  formdata.append('loginId', loginId)
  try {
    return await axios.post(
      `${BASE_URL}/EditMotherTongue1.php?`,formdata
    )
  } catch (err) {
    console.error('Error while edit mother tongue', err.message)
  }
}

export const deleteMotherTongue = async(formdata) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  formdata.append('schoolCode', schoolCode)
  formdata.append('loginId', loginId)
  try {
    return await axios.post(
      `${BASE_URL}/DeleteMotherTongue1.php?`,formdata
    )
  } catch (err) {
    console.error('Error while edit mother tongue', err.message)
  }
}

export const getFeeAccountMapTableData = async() => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/OnlineReg_AjaxController.php?type=fetch_class_account_map_list&schoolCode=${schoolCode}&loginId=${loginId}`,
    )
  } catch (err) {
    console.error('Error while getting table Data', err.message)
  }
}

export const deleteRowTableData = async(formdata) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  formdata.append('schoolCode', schoolCode)
  formdata.append('loginId', loginId)
  try {
    return await axios.post(
      `${BASE_URL}/OnlineReg_AjaxController.php`,formdata
    )
  } catch (err) {
    console.error('Error while deleting row from table', err.message)
  }
}

export const updateFeeAccountMapTableData = async(formdata) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  formdata.append('schoolCode', schoolCode)
  formdata.append('loginId', loginId)
  try {
    return await axios.post(
      `${BASE_URL}/OnlineReg_AjaxController.php`,formdata
    )
  } catch (err) {
    console.error('Error while submit', err.message)
  }
}

export const getPromotedSection = async(classId,section,session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/student/getStudentData.php?getPromotedSectionData=1&session=${session}&classId=${classId}&sectionId=${section}&schoolCode=${schoolCode}&loginId=${loginId}`
    )
  } catch (err) {
    console.error('Error while submit', err.message)
  }
}

export const updateStudentSection = async(formdata) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  formdata.append('schoolCode', schoolCode)
  formdata.append('loginId', loginId)
  try {
    return await axios.post(
      `${BASE_URL}/api-controller/student/getStudentData.php?`,formdata
    )
  } catch (err) {
    console.error('Error while submit', err.message)
  }
}

export const updateStudentRollNo = async(formdata) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  formdata.append('schoolCode', schoolCode)
  formdata.append('loginId', loginId)
  try {
    return await axios.post(
      `${BASE_URL}/api-controller/student/getStudentData.php?`,formdata
    )
  } catch (err) {
    console.error('Error while submit', err.message)
  }
}

export const getPriority = async() => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/SelectDataApi.php?get_student_priorities=1&schoolCode=${schoolCode}&loginId=${loginId}`
    )
  } catch (err) {
    console.error('Error while getting priority', err.message)
  }
}

export const getStudentRollNoTableData = async(formdata) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  formdata.append('schoolCode', schoolCode)
  formdata.append('loginId', loginId)
  try {
    return await axios.post(
      `${BASE_URL}/Update_Student_UI_Controller.php`,formdata
    )
  } catch (err) {
    console.error('Error while getting table data', err.message)
  }
}

export const updateStudentRollNoData = async(formdata) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  formdata.append('schoolCode', schoolCode)
  formdata.append('loginId', loginId)
  try {
    return await axios.post(
      `${BASE_URL}/Update_Student_UI_Controller.php`,formdata
    )
  } catch (err) {
    console.error('Error while updating table data', err.message)
  }
}

export const getStudentDetailsByClass = async(classId, sectionId, session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/student/getStudentData.php?getStudentDetailsbyClass=1&classId=${classId}&classSecId=${sectionId}&session=${session}&schoolCode=${schoolCode}&loginId=${loginId}`,
    )
  } catch (err) {
    console.error('Error while updating table data', err.message)
  }
}

export const promoteClass = async(formdata) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  formdata.append('schoolCode', schoolCode)
  formdata.append('loginId', loginId)
  try {
    return await axios.post(
      `${BASE_URL}/api-controller/student/getStudentData.php?`,formdata
    )
  } catch (err) {
    console.error('Error while promoting class', err.message)
  }
}


export const getAllClusters = async(class_id,session,student_type) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/universal_apis.php?get_all_clusters_by_type_class_id_posted=1&group_type=Regular&Class_Id=${class_id}&student_type=${student_type}&Session=${session}&schoolCode=${schoolCode}&loginId=${loginId}`
    )
  } catch (err) {
    console.error('Error while getting fee groups', err.message)
  }
}

export const getNextRollNo = async(class_id,section,session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/universal_apis.php?Client_Type=NOCHECK&get_roll_no_of_student_by_section=1&class_id=${class_id}&section_id=${section}&student_session=${session}&schoolCode=${schoolCode}&loginId=${loginId}`
    )
  } catch (err) {
    console.error('Error while getting roll no', err.message)
  }
}

export const checkRollNo = async(class_id,section,session,rollNo) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/universal_apis.php?Client_Type=NOCHECK&check_roll_no_of_student=1&class_id=${class_id}&section_id=${section}&student_session=${session}&student_roll_no=${rollNo}}&schoolCode=${schoolCode}&loginId=${loginId}`
    )
  } catch (err) {
    console.error('Error while checking roll no', err.message)
  }
}

export const enrollStudent = async(formdata) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  formdata.append('schoolCode', schoolCode)
  formdata.append('loginId', loginId)
  try {
    return await axios.post(
      `${BASE_URL}/api-controller/student/getStudentData.php?`,formdata
    )
  } catch (err) {
    console.error('Error while enroll student', err.message)
  }
}